import config from '../../config';

export default {
  url: `${config.api.baseURL}/accounts/:id/discharge`,
  options: {
    method: 'PATCH'
  },
  transformer(data) {
    return data;
  }
};



// WEBPACK FOOTER //
// ./src/api/accounts/discharge.js